import type { FC } from 'react';
import { Button, ConfirmationModal, ModalBody, ModalFooter } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';

import { useImageUploadContext } from '../ImageUploadContext';
import { ImageUploadModal } from '../ImageUploadService';

export const ImageUploadSuccessModal: FC = () => {
    const { currentModal, closeModal } = useImageUploadContext();

    if (currentModal !== ImageUploadModal.UploadSuccessModal) {
        return null;
    }

    return (
        <ConfirmationModal
            isOpen
            appear
            title={t('main.imageUpload.successUpdateModalTitle')}
            onClose={closeModal}
            data-cy="image-upload-success"
        >
            <ModalBody>{t('main.imageUpload.successUpdateModalBody')}</ModalBody>
            <ModalFooter>
                <Button onClick={closeModal}>{t('app.close')}</Button>
            </ModalFooter>
        </ConfirmationModal>
    );
};
